module.exports = __webpack_public_path__ + "img/qr_code_en.a9481002.png";